module.exports = __webpack_public_path__ + "static/media/paste.8fbfe2c0.svg";